import {getGenreTranslationKey} from "src/app/modules/stats/utils/genre-translation.util";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from "@angular/core";
import {environment} from "src/environments/environment";
import type {PublicWorkResponse} from "../../interfaces/public-work.interface";
import {TranslateModule} from "@ngx-translate/core";
import {PublicShareDetailsComponent} from "../public-share-details/public-share-details.component";
import {SINGULAR_WORKS_LABEL_KEYS} from "src/app/enums/Works.enum";

@Component({
  selector: "app-public-work-preview",
  templateUrl: "./public-work-preview.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, PublicShareDetailsComponent],
  host: {class: "block min-w-0"},
})
export class PublicWorkPreviewComponent implements OnChanges {
  readonly getGenreTranslationKey = getGenreTranslationKey;
  @Input() data?: PublicWorkResponse;
  @Input() title = "";
  @Input() compact = false;
  @Input() showDetails = false;
  readonly imagesDomain = environment.imagesDomain;
  readonly workTypeLabels = SINGULAR_WORKS_LABEL_KEYS;
  imageUrl?: string;
  imageFailed = false;
  coverFailed = false;
  private cover?: string | null;

  get workTitle(): string {
    const work = this.data?.work;
    if (!work) return this.title;
    return (
      work.title +
      (work.releaseDate ? ` (${work.releaseDate.slice(0, 4)})` : "")
    );
  }

  ngOnChanges(): void {
    if (this.cover !== this.data?.work.cover) this.coverFailed = false;
    this.cover = this.data?.work.cover;
    const image = this.data ? new URL(this.data.social.image) : undefined;
    const next = image
      ? environment.apiDomain + image.pathname + image.search
      : undefined;
    if (next !== this.imageUrl) this.imageFailed = false;
    this.imageUrl = next;
  }
}
